export default {
    TOKEN: 'ODM_COCKPIT_TOKEN',
    ID_TOKEN: 'ID_Token'
};
